import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMenuApi, RequestType } from 'src/services/oms'
import type { MetaStateInReducer } from '../meta'

export const fetchMenu = createAsyncThunk(
  '@menu/menus',
  async (
    { req, isServer, storeOrderId }: { req?: RequestType; isServer?: boolean, storeOrderId?: string },
    thunkApi
  ) => {
    const state = thunkApi.getState() as MetaStateInReducer
    const menuId = state['@meta'].detailMenuSite.data.menu.id as string
    const storeOrderIdFromRedux = state['@meta'].detailMenuSite.data
      .storeOrderId as string
    const mode = state['@meta'].detailMenuSite.mode
    const result = await getMenuApi({ req, isServer, storeOrderId: storeOrderId || storeOrderIdFromRedux, menuId, mode })
    return result.data
  }
)
